import React, { useEffect, useState } from "react";
import {
  useDispatch, connect
} from "react-redux";
import { Link } from "react-router-dom";

import {
  Row, Col, Card, CardBody, CardTitle, CardHeader,
} from "reactstrap";

import {
  Table, Thead, Tbody, Tr, Th, Td
} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import {
  fetchIpBlocks, deleteIpBlock,
} from "store/ipAccessControl/actions";
import CustomPagination from "components/Common/CustomPagination";
import TableLoader from "components/Common/TableLoader";
import DeleteModal from "components/Common/DeleteModal";
import IpAccessControlAdd from "./IpAccessControlAdd";
import { MetaTags } from "react-meta-tags";
import formatDate from "helpers/formatDate";
import { useTranslation } from "react-i18next";

function IpAccessControlList(props) {
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState();
  const { delete: deleteIpPermission } = props.ipAccessControlPermissions;
  const { t } = useTranslation();
  const columns = [
    {
      dataField: "ip",
      text: t("IP Address"),
    },
    {
      dataField: "country",
      text: t("Country"),
      formatter: (item) => item.country || "-",
    },
    {
      dataField: "reason",
      text: t("Reason"),
      formatter: (item) => (item.reason === "auto" ? t("Auto (rate limit)") : t("Manual")),
    },
    {
      dataField: "note",
      text: t("Note"),
      formatter: (item) => item.note || "-",
    },
    {
      dataField: "blockedBy",
      text: t("Blocked By"),
      formatter: (item) => (item.blockedBy ? `${item.blockedBy.firstName} ${item.blockedBy.lastName}` : t("System")),
    },
    {
      dataField: "blockedAt",
      text: t("Blocked At"),
      formatter: (item) => formatDate(item.blockedAt),
    },
    {
      dataField: "expiresAt",
      text: t("Expires At"),
      formatter: (item) => (item.expiresAt ? formatDate(item.expiresAt) : t("Permanent")),
    },
    {
      dataField: "",
      isDummyField: true,
      editable: false,
      text: t("Actions"),
      formatter: (item) => (
        <div className="d-flex gap-3 justify-content-center">
          <Link className="text-danger" to="#">
            <i
              className={`mdi mdi-delete font-size-18 ${!deleteIpPermission ? "d-none" : ""}`}
              id="deletetooltip"
              onClick={() => { setSelectedEntry(item); setDeleteModal(true) }}
            ></i>
          </Link>
        </div>
      ),
    },
  ];
  const [sizePerPage, setSizePerPage] = useState(10);
  const dispatch = useDispatch();

  useEffect(() => {
    loadIpBlocks(1, sizePerPage);
  }, [sizePerPage, 1, props.deleteClearingCounter, props.addSuccess]);

  const loadIpBlocks = (page, limit) => {
    dispatch(fetchIpBlocks({
      page,
      limit,
    }));
  };

  const deleteEntry = () => {
    dispatch(deleteIpBlock(selectedEntry.ip));
  };

  useEffect(() => {
    if (props.deleteClearingCounter > 0 && deleteModal) {
      setDeleteModal(false);
    }
  }, [props.deleteClearingCounter]);

  return (
    <React.Fragment>
      <MetaTags>
        <title>
          IP Access Control
        </title>
      </MetaTags>
      <div className="page-content">
        <div className="container-fluid">
          <h2>{t("IP Access Control")}</h2>
          <Row>
            <Col className="col-12">
              <Card>
                <CardHeader className="d-flex justify-content-between  align-items-center">
                  <CardTitle className="color-primary">{t("Blocked IPs")} ({props.totalDocs})</CardTitle>
                  <IpAccessControlAdd t={t} />
                </CardHeader>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div
                      className="table-responsive mb-0"
                      data-pattern="priority-columns"
                    >
                      <Table
                        id="ip-access-control-table"
                        className="table  table-hover "
                      >
                        <Thead className="text-center table-light" >
                          <Tr>
                            {columns.map((column, index) =>
                              <Th data-priority={index} key={index}><span className="color-primary">{column.text}</span></Th>
                            )}
                          </Tr>
                        </Thead>
                        <Tbody className="text-center" style={{ fontSize: "13px" }}>
                          {props.loading && <TableLoader colSpan={8} />}
                          {!props.loading && props.docs.map((row, rowIndex) =>
                            <Tr key={rowIndex}>
                              {columns.map((column, index) =>
                                <Td key={`${rowIndex}-${index}`}>
                                  { column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                                </Td>
                              )}
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                      <CustomPagination
                        {...props}
                        setSizePerPage={setSizePerPage}
                        sizePerPage={sizePerPage}
                        onChange={loadIpBlocks}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {<DeleteModal loading={props.deleteLoading} onDeleteClick={deleteEntry} show={deleteModal} onCloseClick={() => { setDeleteModal(false) }} bodyText="This IP will be able to attempt login/register again immediately." />}
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  loading: state.ipAccessControlReducer.loading || false,
  docs: state.ipAccessControlReducer.docs || [],
  page: state.ipAccessControlReducer.page || 1,
  totalDocs: state.ipAccessControlReducer.totalDocs || 0,
  totalPages: state.ipAccessControlReducer.totalPages || 0,
  hasNextPage: state.ipAccessControlReducer.hasNextPage,
  hasPrevPage: state.ipAccessControlReducer.hasPrevPage,
  limit: state.ipAccessControlReducer.limit,
  nextPage: state.ipAccessControlReducer.nextPage,
  pagingCounter: state.ipAccessControlReducer.pagingCounter,
  prevPage: state.ipAccessControlReducer.prevPage,
  deleteLoading: state.ipAccessControlReducer.deleteLoading,
  deleteClearingCounter: state.ipAccessControlReducer.deleteClearingCounter,
  ipAccessControlPermissions: state.Profile.permissions?.ipAccessControl || {},
  addSuccess: state.ipAccessControlReducer.addSuccess
});
export default connect(mapStateToProps, null)(IpAccessControlList);
